var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookIconFillAble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5947 16.9994L20.0506 14.1051H17.242V12.2239C17.242 11.4324 17.6341 10.6591 18.888 10.6591H20.1828V8.19446C19.4288 8.07432 18.6668 8.00933 17.9031 8C15.5915 8 14.0824 9.38835 14.0824 11.8982V14.1051H11.52V16.9994H14.0824V24H17.242V16.9994H19.5947Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconFillAble);
export default __webpack_public_path__ + "static/media/facebookIconFillAble.0d5b5f94.svg";
export { ForwardRef as ReactComponent };